<template>
    <!-- 营销管理－新增活动 -->
    <content-view class="new-coupon">
        <div slot="header" v-if="$route.name !== 'detailActive'">
            <div class="ml32 mr32">
                <a-steps :current="current" size="small">
                    <a-step title="活动信息" />
                    <a-step title="商品信息" />
                    <a-step title="奖品配置" />
                    <a-step title="发布上架" />
                </a-steps>
            </div>
        </div>
        <a-form :form="form">
            <div v-show="current === 0 || current === 3">
                <a-card title="活动信息">
                    <a-form-item v-bind="formItemLayout" label="活动名称">
                        <a-input
                            :disabled="isDisable"
                            placeholder="请输入活动名称!(30字符以内)"
                            v-decorator="[
                                'actName',
                                {rules: [{ required: true, message: '请输入活动名称!(30字符以内)',max: 30}]}
                            ]"
                        />
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="活动日期">
                        <a-range-picker
                            style="width: 100%"
                            :disabled="isDisable"
                            showTime
                            format="YYYY-MM-DD HH:mm"
                            v-decorator="['rangePicker',{rules: [{ required: true, message: '请选择活动日期'}]}]"
                        />
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="活动介绍">
                        <a-textarea placeholder="请输入活动介绍" :rows="4"
                        :disabled="isDisable"
                        v-decorator="[
                            'actContent',
                            {rules: [{ required: true, message: '请输入活动介绍'}]}
                        ]" />
                    </a-form-item>
                </a-card>
                <div class="mb24"></div>
            </div>
            <div class="step-two" v-show="current === 1 || current === 3">
                <a-card title="商品基本信息">
                    <a-form-item v-bind="formItemLayout" label="商品名称">
                        <a-input
                            :disabled="isDisable"
                            placeholder="请输入请输入商品名称!(35字符以内)"
                            v-decorator="['commodityName',{rules: [{ required: true, message: '请输入商品名称!(35字符以内)',max: 35}]}]"
                        />
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="商品价格">
                        <a-input-number
                        style="width:100%"
                        placeholder="请输入"
                        :min="0"
                        :precision="2"
                        :disabled="isDisable"
                        v-decorator="['price',{rules: [{ required: true, message: '请输入商品价格'}]}]"
                        />
                    </a-form-item>
                    <template v-for="(item,index) in actProductList">
                        <div v-if="item.isShow" :key="index" class="suit-shop pt24">
                            <div class="operat" v-if="!isDisable">
                                <a class="text-primary" @click="addActProductList">新增 </a>
                                <a class="text-primary" v-if="usableActProductList.length > 1" @click="deleteActProductList(index)">删除</a>
                            </div>
                            <a-form-item :labelCol="{span: 5}" :wrapperCol="{span: 19}" :label="'包含商品'+ item.index">
                                <a-input
                                    :disabled="isDisable"
                                    placeholder="请输入包含商品!(20字符以内)"
                                    style="width: 240px"
                                    v-model="item.name"
                                />
                                <span class="ml8 mr8">数量</span>
                                <a-input-number
                                    style="width:100px"
                                    placeholder="请输入"
                                    :min="1"
                                    :precision="0"
                                    :disabled="isDisable"
                                    v-model="item.num"
                                    />
                            </a-form-item>
                        </div>
                    </template>
                    <a-form-item v-bind="formItemLayout" label="商品类型">
                        <a-radio-group v-decorator="['type',{initialValue: 1}]" :disabled="isDisable" @change="onChangeType">
                            <a-radio :value="1">独立售卖商品</a-radio>
                            <a-radio :value="2">定金商品</a-radio>
                            <a-radio :value="3">尾款商品</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="type" v-bind="formItemLayout" label="绑定对应定金商品">
                        <a-select
                        :disabled="isDisable"
                        placeholder="请选择"
                        v-decorator="['bindingId',{rules: [{required: type, message: '请选择',}]}]"
                        >
                            <a-select-option :value="item.id" v-for="item in depositList" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="是否可用优惠券购买">
                        <a-radio-group v-decorator="['couponState',{initialValue: 0}]" :disabled="isDisable">
                            <a-radio :value="0">否</a-radio>
                            <a-radio :value="1">是</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="是否支持退款">
                        <a-radio-group v-decorator="['returnState',{initialValue: 0}]" :disabled="isDisable">
                            <a-radio :value="0">不支持</a-radio>
                            <a-radio :value="1">支持</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="是否限购">
                        <a-radio-group v-decorator="['limitState',{initialValue: 0}]" :disabled="isDisable" @change="onChangeLimitState">
                            <a-radio :value="0">不限购</a-radio>
                            <a-radio :value="1">限购</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="limitState" v-bind="formItemLayout" label="限购数量">
                        <a-input-number
                            style="width:100%"
                            placeholder="请输入限购数量"
                            :min="1"
                            :precision="0"
                            :disabled="isDisable"
                            v-decorator="['limitNum',{rules: [{ required: limitState, message: '请输入限购数量'}]}]"
                            />
                    </a-form-item>
                </a-card>
                <div class="mb24"></div>
                <a-card title="商品图文信息">
                    <a-form-item class="mt24" v-bind="formItemLayout" label="商品展示图片" required>
                        <images-uploader :limitNum="5" ref="imageUpload" :readOnly="isDisable"></images-uploader>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="商品图文详情" required>
                        <rich-text ref="rich" :list="contentList" v-if="!isDisable"></rich-text>
                        <rich-text-viewer :list="contentList" v-else></rich-text-viewer>
                    </a-form-item>
                </a-card>
                <div class="mb24"></div>
                <a-card title="商品规格信息">
                    <a-button v-show="!isDisable" slot="extra" type="primary" @click="visibleAddAcp = true">添加商品规格</a-button>
                    <a-table
                    :bordered="true"
                    :pagination="false"
                    :dataSource="actSpeList"
                    :columns="columns"
                    :rowKey="(record,index) => index"
                    >
                        <span slot="index" slot-scope="a,item,i">{{i+1}}</span>
                        <span slot="action" slot-scope="a,item">
                            <span v-if="isDisable" class="text-disabled">删除</span>
                            <a-popconfirm
                                v-else
                                title="确认删除吗？"
                                @confirm="deleteAcpList(item.id)"
                                >
                                <a class="text-primary">删除</a>
                            </a-popconfirm>
                        </span>
                    </a-table>
                    <a-modal :destroyOnClose="true" centered title="添加商品规格" v-model="visibleAddAcp" @ok="addAcpList" okText="确认" cancelText="取消">
                        <a-form :form="formAcp">
                            <a-form-item class="mt24" :labelCol="{span: 5}" :wrapperCol="{span: 18}" label="规格名称">
                                <a-input
                                    placeholder="请输入"
                                    v-decorator="['name',{rules: [{ required: true, message: '请输入活动名称'}]}]"
                                />
                            </a-form-item>
                            <a-form-item :labelCol="{span: 5}" :wrapperCol="{span: 18}" label="对应价格">
                                <a-input-number
                                style="width:100%"
                                placeholder="请输入"
                                :min="0"
                                :precision="2"
                                v-decorator="['price',{rules: [{ required: true, message: '请输入对应价格'}]}]"
                                />
                            </a-form-item>
                            <a-form-item :labelCol="{span: 5}" :wrapperCol="{span: 18}" label="库存数量">
                                <a-input-number
                                style="width:100%"
                                placeholder="请输入"
                                :min="0"
                                :precision="0"
                                v-decorator="['num',{rules: [{ required: true, message: '请输入库存数量'}]}]"
                                />
                            </a-form-item>
                        </a-form>
                    </a-modal>
                </a-card>
                <div class="mb24"></div>
            </div>
            <div class="step-three" v-show="current === 2 || current === 3">
                <a-card title="商品绑定配置">
                    <div v-for="(item,index) in actSpeList" :key="index">
                        <a-card :title="'规格'+(index+1)+': '+item.name">
                            <a-button v-show="!isDisable" slot="extra" @click="addCodeModal(item.name)">绑定二维码库</a-button>
                            <a-table
                            v-if="item.codeList.length > 0"
                            :bordered="true"
                            :pagination="false"
                            :dataSource="item.codeList"
                            :columns="columnsCode"
                            :rowKey="(record,index) => index"
                            >
                                <span slot="index" slot-scope="a,row,i">{{i+1}}</span>
                                <span slot="action" slot-scope="a,row">
                                    <span v-if="isDisable" class="text-disabled">删除</span>
                                    <a-popconfirm
                                        v-else
                                        title="确认删除吗？"
                                        @confirm="deleteCodeList(item.name,row.codeId)"
                                        >
                                        <a class="text-primary">删除</a>
                                    </a-popconfirm>
                                </span>
                            </a-table>
                        </a-card>
                        <div class="mb24"></div>
                    </div>
                    <a-modal :width="560" :destroyOnClose="true" centered title="绑定二维码库" v-model="visibleAddCode" @ok="addCodeList" okText="确认" cancelText="取消">
                        <a-form :form="formCode">
                            <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 20}" label="二维码类型">
                                <a-radio-group v-decorator="['codeType',{initialValue: 1}]" :disabled="isDisable" @change="onChangeCodeType">
                                    <a-radio :value="1">线上票</a-radio>
                                    <a-radio :value="2">线下票</a-radio>
                                    <a-radio :value="3">优惠券</a-radio>
                                    <a-radio :value="4">储值卡</a-radio>
                                    <a-radio :value="5">新优惠券</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item v-show="codeType" :labelCol="{span: 4}" :wrapperCol="{span: 18}" label="门店选择">
                                <a-select
                                :disabled="isDisable"
                                @change="getCodeList"
                                placeholder="请选择"
                                v-decorator="['shopId',{rules: [{required: codeType, message: '请选择'}]}]"
                                >
                                    <a-select-option :value="item.id" v-for="item in shopList" :key="item.id">{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 18}" label="二维码库">
                                <a-select
                                :disabled="isDisable"
                                placeholder="请选择"
                                v-decorator="['bindingId',{rules: [{required: true, message: '请选择',}]}]"
                                >
                                    <a-select-option :value="item.codeId" v-for="item in codeList" :key="item.codeId">{{item.codeName}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-form>
                    </a-modal>
                </a-card>
                <div class="mb24"></div>
                <a-card title="奖品配置">
                    <a-button v-show="!isDisable" slot="extra" type="primary" @click="addPrize">添加奖品</a-button>
                    <div v-for="(item,index) in prizeList" :key="index">
                        <a-card :title="'奖品'+(index+1)">
                            <a-button v-show="!isDisable" slot="extra" @click="addPrizeCon(index)">添加奖品内容</a-button>
                            <a-popconfirm
                                v-show="!isDisable" slot="extra"
                                title="确认删除该奖品吗？删除奖品后奖品内容也一并删除！"
                                @confirm="deletePrize(index)"
                                >
                                <a-button>删除</a-button>
                            </a-popconfirm>
                            <a-table
                            v-if="item.detailsDTO.length > 0"
                            :bordered="true"
                            :pagination="false"
                            :dataSource="item.detailsDTO"
                            :columns="columnsPrize"
                            :rowKey="(record,index) => index"
                            >
                                <span slot="index" slot-scope="a,row,i">{{i+1}}</span>
                                <span slot="action" slot-scope="a,row">
                                    <template>
                                        <span v-if="isDisable" class="text-disabled">编辑<a-divider type="vertical"/></span>
                                        <a v-else class="text-primary" @click="editPrizeCon(index,row.name)">编辑<a-divider type="vertical"/></a>
                                    </template>
                                    <template>
                                        <span v-if="isDisable" class="text-disabled">删除</span>
                                        <a-popconfirm
                                            v-else
                                            title="确认删除吗？"
                                            @confirm="deletePrizeCon(index,row.name)"
                                            >
                                            <a class="text-primary">删除</a>
                                        </a-popconfirm>
                                    </template>
                                </span>
                            </a-table>
                        </a-card>
                        <div class="mb24"></div>
                    </div>
                    <a-modal :width="560" :destroyOnClose="true" centered :title="prizeTitle+'奖品内容'" v-model="visibleAddPrize" @ok="addCodePrize" okText="确认" cancelText="取消">
                        <a-form :form="formPrize">
                            <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 18}" label="奖品名称">
                                <a-input
                                placeholder="请输入奖品名称(20字以内)"
                                v-decorator="['name',{rules: [{ required: true, message: '请输入奖品名称(20字以内)',max: 20}]}]"
                                />
                            </a-form-item>
                            <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 18}" label="数量">
                                <a-input-number
                                style="width:100%"
                                placeholder="请输入"
                                :min="1"
                                :precision="0"
                                v-decorator="['num',{rules: [{ required: true, message: '请输入数量'}]}]"
                                />
                            </a-form-item>
                            <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 20}" label="二维码类型">
                                <a-radio-group v-decorator="['codeType',{initialValue: 1}]" :disabled="isDisable" @change="onChangeCodeType">
                                    <a-radio :value="1">线上票</a-radio>
                                    <a-radio :value="2">线下票</a-radio>
                                    <a-radio :value="3">优惠券</a-radio>
                                    <a-radio :value="4">储值卡</a-radio>
                                    <a-radio :value="5">新优惠券</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item v-show="codeType" :labelCol="{span: 4}" :wrapperCol="{span: 18}" label="门店选择">
                                <a-select
                                :disabled="isDisable"
                                @change="getCodeList"
                                placeholder="请选择"
                                v-decorator="['shopId',{rules: [{required: false, message: '请选择'}]}]"
                                >
                                    <a-select-option :value="item.id" v-for="item in shopList" :key="item.id">{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item :labelCol="{span: 4}" :wrapperCol="{span: 18}" label="二维码库">
                                <a-select
                                :disabled="isDisable"
                                placeholder="请选择"
                                v-decorator="['bindingId',{rules: [{required: false, message: '请选择',}]}]"
                                >
                                    <a-select-option :value="item.codeId" v-for="item in codeList" :key="item.codeId">{{item.codeName}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-form>
                    </a-modal>
                </a-card>
                <div class="mb24"></div>
            </div>
        </a-form>
        <div class="text-center pt24 pb24" style="background-color:#fff">
            <a-button @click="$router.go(-1)">返回</a-button>
            <a-button v-if="$route.name !== 'detailActive' && current > 0" @click="current--">上一步</a-button>
            <a-button v-if="current === 0" type="primary" @click="toStepTwo">下一步</a-button>
            <a-button v-if="current === 1" type="primary" @click="toStepThree">下一步</a-button>
            <a-button v-if="current === 2" type="primary" @click="toStepFour">下一步</a-button>
            <a-button @click="handleSubmit" v-if="($route.name !== 'detailActive') && current === 3" type="primary" :loading="loading" >保存</a-button>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import ImagesUploader from '@/components/common/images-uploader.component';
    import richText from '@/components/modules/rich-text.component';
    import richTextViewer from '@/components/modules/rich-text-viewer.component';
    import { mapGetters } from "vuex";
    const columns = [{
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "规格名称",
        dataIndex: "name"
    },
    {
        title: "对应价格",
        dataIndex: "price"
    },
    {
        title: "库存数量",
        dataIndex: "num"
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" }
    }];
    const columnsCode = [{
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "绑定二维码库名称",
        dataIndex: "codeName"
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" }
    }];
    const columnsPrize = [{
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "奖品名称",
        dataIndex: "name"
    },
    {
        title: "奖品数量",
        dataIndex: "num"
    },
    {
        title: "绑定二维码库名称",
        dataIndex: "codeName"
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" }
    }];
export default {
    name: "ticket",
    props: {},
    data() {
        return {
            current: 0,
            id: undefined,
            columns,
            columnsCode,
            columnsPrize,
            actSpeList: [],
            codeList: [],
            imgUrlList: [],
            contentList: [],
            depositList: [],
            shopList: [],
            prizeList: [],
            actProductList: [{
                name: '',
                num: undefined,
                isShow: true,
                index: 1
            }],
            formItemLayout: {
                labelCol: { span: 8 },
                wrapperCol: { span: 10 }
            },
            isDisable: false,
            loading: false,
            limitState: false,
            type: false,
            visibleAddAcp: false,
            visibleAddCode: false,
            codeType: false,
            visibleAddPrize: false,
            codeName: '',
            prizeIndex: 0,
            prizeTitle: '',
            prizeCon: {}
        };
    },
    components: {
        ImagesUploader,
        richText,
        richTextViewer
    },
    computed: {
        ...mapGetters(["shopId"]),
        /**
         * @usableActProductList 有效的商品列表
         */
        usableActProductList () {
            let array = this.actProductList.filter(item => item.isShow);
            array.forEach((item,$index) => {
                item.index = $index + 1;
            });
            return array;
        }
    },
    watch: {
        'current'() {
            this.isDisable = this.$route.name === 'detailActive' || this.current === 3
        }
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.formAcp = this.$form.createForm(this);
        this.formCode = this.$form.createForm(this);
        this.formPrize = this.$form.createForm(this);
    },
    mounted() {
        this.id = this.$route.query.id
        this.current = this.$route.name === 'detailActive' ? 3 : 0
        this.isDisable = this.$route.name === 'detailActive'
        this.$route.name !== 'newActive' && this.getActiveDetail(this.id)

        this.getShopList()
        this.getCodeList()
        this.getDepositList()
    },
    methods: {
        // 系统店铺获取
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                this.shopList = res;
            });
        },
        addActProductList() {
            this.actProductList.push(
                {
                    name: '',
                    num: undefined,
                    isShow: true,
                    index: this.usableActProductList.length + 1
                }
            )
        },
        deleteActProductList(index) {
            this.actProductList[index].isShow = false
        },
        addAcpList() {
            this.formAcp.validateFields((err, values) => {
                if (!err) {
                    this.actSpeList.push(
                        {
                            name: values.name,
                            num: values.num,
                            price: values.price,
                            codeIds: '',
                            codeList: []
                        }
                    )
                    this.visibleAddAcp = false
                }
            });
        },
        deleteAcpList(id) {
            this.actSpeList = this.actSpeList.filter(item => item.id !== id)
        },
        uploaded(val) {
            this.imgUrl = val
        },
        // 切换是否限购
        onChangeLimitState(e) {
            this.limitState = e.target.value === 1
            this.$nextTick(() => {
                this.form.validateFields(['limitNum'], { force: true });
            })
        },
        // 切换商品类型
        onChangeType(e) {
            this.type = e.target.value === 3
            this.$nextTick(() => {
                this.form.validateFields(['bindingId'], { force: true });
            })
        },
        // 获取定金商品
        getDepositList() {
            this.$api.changeCode
            .deposit()
            .then(res => {
                this.depositList = res
            });
        },
        // 打开添加二维码弹框
        addCodeModal(name) {
            this.visibleAddCode = true
            this.codeName = name
        },
        // 获取二维码库列表
        getCodeList() {
            this.$nextTick(() => {
                let type
                let shopId
                if(this.visibleAddCode) {
                    type = this.formCode.getFieldValue('codeType') || 1
                    shopId = type === 2 ? this.formCode.getFieldValue('shopId') : undefined
                }else {
                    type = this.formPrize.getFieldValue('codeType') || 1
                    shopId = type === 2 ? this.formPrize.getFieldValue('shopId') : undefined
                }

                this.$api.changeCode
                .codeList({
                    body: {
                        shopId: shopId,
                        type: type
                    }
                })
                .then(res => {
                    this.codeList = res
                });
            })
        },
        // 切换二维码类型
        onChangeCodeType(e) {
            this.getCodeList()
            this.codeType = e.target.value === 2
            this.$nextTick(() => {
                this.formCode.setFieldsValue({'shopId':undefined,'bindingId':undefined});
                this.formPrize.setFieldsValue({'shopId':undefined,'bindingId':undefined});
            })
        },
        // 添加二维码
        addCodeList() {
            this.formCode.validateFields((err, values) => {
                if (!err) {
                    this.actSpeList.forEach(item => {
                        if(item.name === this.codeName) {
                            let code = this.codeList.filter(code => code.codeId === values.bindingId)
                            item.codeList = item.codeList.filter(code => code.codeId === values.bindingId).length === 0 ? item.codeList.concat(code) : item.codeList
                        }
                    })
                    this.visibleAddCode = false
                }
            });
        },
        // 删除二维码
        deleteCodeList(name,codeId) {
            this.actSpeList.forEach(item => {
                if(item.name === name) {
                    item.codeList = item.codeList.filter(code => code.codeId !== codeId)
                }
            })
        },

        // 添加奖品
        addPrize() {
            this.prizeList.push({
                detailsDTO: []
            })
        },
        // 删除奖品
        deletePrize(index) {
            this.prizeList.splice(index,1)
        },
        // 打开添加奖品内容弹框
        addPrizeCon(index) {
            this.visibleAddPrize = true
            this.prizeIndex = index
            this.prizeTitle = '添加'
        },
        // 打开编辑奖品内容弹框
        editPrizeCon(index,name) {
            this.visibleAddPrize = true
            this.prizeIndex = index
            this.prizeTitle = '编辑'

            let prizeCon = this.prizeList[index].detailsDTO.filter(item => item.name === name)[0]
            this.prizeCon = prizeCon
            let valuesForm = {
                name: prizeCon.name,
                num: prizeCon.num,
                shopId: prizeCon.shopId,
                bindingId: prizeCon.codeId,
                codeType: prizeCon.type,
            };
            this.$nextTick(() => {
                this.formPrize.setFieldsValue(valuesForm)
            })
        },
        // 添加奖品内容
        addCodePrize() {
            this.formPrize.validateFields((err, values) => {
                if (!err) {
                    let flag = false
                    this.prizeList[this.prizeIndex].detailsDTO.forEach(item => {
                        if(values.name === item.name) {
                            this.$message.error('奖品内容名称不能重复，请重新输入！')
                            flag = true
                        }
                    })
                    if(flag) {return false}

                    if(this.prizeTitle === '添加') {
                        this.prizeList[this.prizeIndex].detailsDTO.push({
                            name: values.name,
                            num: values.num,
                            shopId: values.shopId,
                            type: values.codeType,
                            codeId: values.bindingId,
                            codeName: values.bindingId && this.codeList.filter(code => code.codeId === values.bindingId)[0].codeName,
                        })
                    }else if(this.prizeTitle === '编辑'){
                        let name = this.prizeCon.name
                        let prizeCon = this.prizeList[this.prizeIndex].detailsDTO.filter(item => item.name === name)[0]
                        this.prizeList[this.prizeIndex].detailsDTO.forEach(item => {
                            if(item.name === name) {
                                item.name = values.name;
                                item.num = values.num;
                                item.shopId = values.shopId;
                                item.type = values.codeType;
                                item.codeId = values.bindingId;
                                item.codeName = values.bindingId && this.codeList.filter(code => code.codeId === values.bindingId)[0].codeName;
                            }
                        })
                    }
                    this.visibleAddPrize = false
                }
            });
        },
        // 删除奖品内容
        deletePrizeCon(index,name) {
            this.prizeList[index].detailsDTO = this.prizeList[index].detailsDTO.filter(item => item.name !== name)
        },

        toStepTwo() {
            this.form.validateFields(['actName','rangePicker','actContent'],(err, values) => {
                if(!err) {
                    this.current ++
                }
            })
        },
        toStepThree() {
            this.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    let flag = false
                    this.usableActProductList.forEach((item,index) => {
                        if(!item.name) {
                            this.$message.error('请输入包含商品'+(index+1))
                            flag = true
                        }
                        if(!item.num) {
                            this.$message.error('请输入包含商品'+(index+1)+'数量')
                            flag = true
                        }
                        if(this.actProductList.filter(v => v.name === item.name).length > 1) {
                            this.$message.error('请输入包含商品名称不能重复')
                            flag = true
                        }
                    })
                    if(flag) return false

                    this.imgUrlList = this.$refs.imageUpload.fileList.filter(item => item.status === 'done').map(item => {return item.url});
                    if (this.imgUrlList.length === 0) {
                        this.$message.error('请添加商品展示图片')
                        return false
                    }

                    this.contentList = this.$utils.deepClone(this.$refs.rich.getData())
                    if(this.contentList.length === 0) {
                        this.$message.error('请添加商品图文详情')
                        return false
                    }

                    if(this.actSpeList.length === 0) {
                        this.$message.error('请添加商品规格')
                        return false
                    }
                    this.current ++
                }
            })
        },
        toStepFour() {
            this.actSpeList.forEach(item => {
                let codeIds = []
                item.codeList.forEach(code => {
                    codeIds.push(code.codeId)
                })
                item.codeIds = codeIds.join(',')
            })

            this.current ++
        },
        handleSubmit() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    values.startTime = values.rangePicker[0].format('YYYY-MM-DD HH:mm')
                    values.endTime = values.rangePicker[1].format('YYYY-MM-DD HH:mm')
                    delete values.rangePicker

                    values.shopId = this.shopId

                    this.loading = true
                    this.$api.changeCode[this.id ? 'editActivity' : 'addActivity']({
                        body: {
                            ...values,
                            id: this.id,
                            actProductList: this.usableActProductList,
                            imgUrlList: this.imgUrlList,
                            actSpeList: this.actSpeList,
                            contentList: this.contentList,
                            actTrophyList: this.prizeList
                        }
                    })
                    .then(res => {
                            this.$router.go(-1)
                            this.$message.success("操作成功", 2);
                            this.loading = false
                        },
                        err => {
                            this.$message.error(err.mag, 2);
                            this.loading = false
                        }
                    );
                }
            });
        },

        // 查看详情--获取优惠券详情
        getActiveDetail(id) {
            this.$api.changeCode
            .detailActivity({
                params: {id: id}
            }).then(res => {
                res.actProductList.forEach((item,index) => {
                    item.isShow = true;
                    item.index = index + 1
                })

                let valuesForm = {
                    actName: res.actName,
                    rangePicker: [this.$moment(res.startTime,'YYYY-MM-DD HH:mm'),this.$moment(res.endTime,'YYYY-MM-DD HH:mm')],
                    actContent: res.actContent,
                    commodityName: res.commodityName,
                    price: res.price,
                    type: res.type,
                    couponState: res.couponState,
                    returnState: res.returnState,
                    limitState: res.limitState,
                    limitNum: res.limitNum,
                };
                this.actProductList = res.actProductList;
                this.actSpeList = res.actSpeList;
                this.type = res.type === 3
                this.limitState = res.limitState === 1

                if(this.type) {
                    valuesForm.bindingId = res.bindingId
                }

                this.contentList = []
                res.contentList.map(item => {
                    this.contentList.push(JSON.parse(item))
                })

                let images = res.imgUrlList.map((item,index) => {
                    return {
                        uid: index,
                        name: `${index}.png`,
                        status: 'done',
                        url: item,
                    }
                });
                this.$refs.imageUpload.fileList = images;

                this.prizeList = res.actTrophyList

                this.$nextTick(() => {
                    this.form.setFieldsValue(valuesForm)
                })
            })
        },
    }
};
</script>
<style lang="scss">
.new-coupon {
    .suit-shop {
        margin:0 auto 24px;
        padding-bottom: 1px;
        width: 55%;
        background-color: #f8f8f8;
        position: relative;
        .operat {
            position: absolute;
            right: -64px;
            top: 24px;
        }
    }
}
</style>